import React, { Component } from 'react';
 import { connect } from 'react-redux';
 
 import './ParkingModelMotorcycle.scss';
 import { Input} from 'reactstrap';
 
 import {
     InputWithHours,
     HeaderSection,
     AddButton,
     Card,
   } from '../../helpers';
 
class ParkingModelMotorcycle extends Component {
    constructor(props) {
        super(props);
        this.state = {
            'weekdayNoRedeemListInputFeeModel' : [''],
            'weekdayNoRedeemAfterParkingHoursFee' : '',
            'weekdayRedeemListInputFeeModel' : [''],
            'weekdayRedeemAfterParkingHoursFee' : '',
        }
    }
 
    handleCallback = (number, stateName) => {
        this.setState(prevState => ({
            [stateName]: prevState[stateName].slice(0, number)
        }));
    };
 
    handleAddList = (listName) => {
        this.setState(prevState => ({
            [listName]: [...prevState[listName], ''],
        }));
     }
 
    handleInputFeeModel = (listInputFeeModel, stateName) => {
        return (
            <div className="box-input">
                {listInputFeeModel.map((ele, index) => (
                    <div className="space-box-input" key={index}>
                        <InputWithHours
                            id="search-license-plate"
                            template="a"
                            icon="fas fa-search"
                            placeholder="Input fee"
                            value={ele}
                            onChange={(event) => this.handleChangeInputFee(event, index, stateName)}
                            number={index}
                            callback={() => this.handleCallback(index, stateName)}
                            isHideButton={index === 0 ? true : false}
                        />
                    </div>
                ))}
            </div>
        );
    }
 
    handleChangeInputFee = (event, index, stateName) => {
        const updatedList = [...this.state[stateName]];
        updatedList[index] = event.target.value;
        this.setState({ [stateName]: updatedList });
    }
 
    weekDayBox = () => {
        const { weekdayNoRedeemAfterParkingHoursFee , weekdayRedeemAfterParkingHoursFee , weekdayNoRedeemListInputFeeModel , weekdayRedeemListInputFeeModel} = this.state;
 
        return (
            <>
            <Card>
            <div className="gray-background">
            <HeaderSection title='Weekday' isHeader={true} isBlack={true}/>
             <div className="row-items">
                 <div className="box-item">
                     <div className="title-input">Weekday - No redeem Fee model </div>
                     <div className="group-box-input">
                     {this.handleInputFeeModel(weekdayNoRedeemListInputFeeModel, 'weekdayNoRedeemListInputFeeModel')}
                     <div className="text-add">
                        <AddButton text='Add  step fees' handleOnClick={() => this.handleAddList('weekdayNoRedeemListInputFeeModel')} />
                     </div>
                     </div>
                     </div>
             </div>
             <div className="row-items ">
                 <div className="box-item">
                     <div className="width-input">
                     <div className="title-input">After parking hours fee</div>
                 <Input
                     id="building-contact-name"
                     className={`template-d`}
                     placeholder="Input after parking hours fee "
                     value={weekdayNoRedeemAfterParkingHoursFee}
                     onChange={event => this.handleEvent(event, '')}
                     />
                 </div>
                 </div>
             </div>
             <div className="row-items">
                 <div className="box-item">
                     <div className="title-input">Weekday - Redeem Fee model </div>
                     <div className="group-box-input">
                     {this.handleInputFeeModel(weekdayRedeemListInputFeeModel, 'weekdayRedeemListInputFeeModel')}
                     <div className="text-add">
                        <AddButton text='Add  step fees' handleOnClick={() => this.handleAddList('weekdayRedeemListInputFeeModel')} />
                     </div>
                     </div>
                     </div>
             </div>
             <div className="row-items ">
                 <div className="box-item">
                     <div className="width-input">
                     <div className="title-input">After parking hours fee</div>
                 <Input
                     id="building-contact-name"
                     className={`template-d`}
                     placeholder="Input after parking hours fee "
                     value={weekdayRedeemAfterParkingHoursFee}
                     onChange={event => this.handleEvent(event, '')}
                     />
                 </div>
                 </div>
             </div>
             </div>
            </Card>
            
             
             </>
         );
     } 
 
     render() {
         return (
            <div className='ParkingModelMotorcycle'>
            <HeaderSection title='Parking Model' isHeader={true} />
            {this.weekDayBox()}
            </div>
         )
     }
 }
 
const mapStateToProps = ({ }) => ({});
 
export default connect(mapStateToProps)(ParkingModelMotorcycle);
